import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { StorageKeys } from '@core/enums';
import { API, environment } from '@core/envs';
import { IGarageResponse, IVehicleFromUsers } from '@core/interface';
import { firstValueFrom, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MyGarageService {
  readonly #http = inject(HttpClient);

  readonly #userVehiclesSignal = signal<IVehicleFromUsers[]>([]);
  readonly userVehicles = this.#userVehiclesSignal.asReadonly();

  async loadUserVehicles(): Promise<void> {
    const url = `${environment.getRoute(API.users)}/vehicles/user/garage`;

    await firstValueFrom(
      this.#http
        .get<IGarageResponse>(url, { params: { region: 'SA' } })
        .pipe(
          tap((response) => {
            this.#userVehiclesSignal.set(response.vehicles);
            sessionStorage.setItem(
              StorageKeys.USER_VEHICLES,
              JSON.stringify(response.vehicles)
            );
            localStorage.setItem(
              '@Ford-userVehicles',
              JSON.stringify(response.vehicles)
            );
          })
        )
    );
  }
}
